import { HttpErrorResponse } from '@angular/common/http';
import { PaymentInclusionExclusionRulesResponseV1 } from '@arc/unified-payments-frontend/shared-payment';
import { createActionGroup, props } from '@ngrx/store';

export const PoiSelectPaymentMethodPaymentRulesActions = createActionGroup({
  source: 'POI Select Payment Method Component Payment Rules',
  events: {
    'Inclusion Exclusion List Update': props<{
      payload: PaymentInclusionExclusionRulesResponseV1;
    }>(),
    'Inclusion Exclusion List Error': props<{
      payload: HttpErrorResponse;
    }>(),
  },
});
